/* FL14-ATC-001: product page Add to cart guard. One click adds once; after a confirmed add the button reads "Added to cart" and the sticky bar opens the cart; a failed add keeps the inputs and allows a retry. Works alongside flooritize-ui.js without changing its cart request. */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function state(root) { return root.__flzAtc || (root.__flzAtc = { busy: false, added: false, fromBar: false }); }
  function rootOf(el) { return el && el.closest && el.closest('[data-flz-product]'); }
  function label(root) { var b = root.querySelector('[data-flz-add]'); return b ? b.textContent : 'Add to cart'; }
  function show(root) {
    var m = root.querySelector('[data-flz-msg]');
    if (m && m.scrollIntoView) m.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.addEventListener('click', function (e) {
    var add = e.target.closest && e.target.closest('[data-flz-add],[data-flz-baradd]'); if (!add) return;
    var root = rootOf(add); if (!root) return; var s = state(root), main = root.querySelector('[data-flz-add]');
    var isBar = add.hasAttribute('data-flz-baradd');
    if (s.added) { e.stopImmediatePropagation(); e.preventDefault(); if (isBar) window.location.href = ROOT + 'cart'; return; }
    if (s.busy || !main || main.disabled) { e.stopImmediatePropagation(); e.preventDefault(); return; }
    s.busy = true; s.fromBar = isBar;
  }, true);
  document.addEventListener('flooritize:cart-updated', function () {
    document.querySelectorAll('[data-flz-product]').forEach(function (root) {
      var s = state(root); if (!s.busy) return;
      s.busy = false; s.added = true;
      setTimeout(function () {
        var b = root.querySelector('[data-flz-add]'), bb = root.querySelector('[data-flz-baradd]');
        if (b && /add to cart/i.test(b.textContent)) { b.textContent = 'Added to cart'; b.disabled = true; }
        if (bb) bb.textContent = 'View cart';
        if (s.fromBar) show(root);
      }, 0);
    });
  });
  function watch(root) {
    var m = root.querySelector('[data-flz-msg]'); if (!m || m.__flzW) return; m.__flzW = 1;
    new MutationObserver(function () {
      var s = state(root);
      if (s.busy && m.querySelector('.flz-note')) { s.busy = false; if (s.fromBar) show(root); }
    }).observe(m, { childList: true, subtree: true });
  }
  function reset(root) {
    var s = state(root); if (!s.added) return; s.added = false;
    var b = root.querySelector('[data-flz-add]'), bb = root.querySelector('[data-flz-baradd]');
    if (b && b.textContent === 'Added to cart') { b.textContent = 'Add to cart'; b.disabled = false; }
    if (bb) bb.textContent = label(root);
  }
  document.addEventListener('input', function (e) { var r = rootOf(e.target); if (r && e.target.closest('[data-flz-inputs]')) reset(r); }, true);
  document.addEventListener('click', function (e) {
    var t = e.target; var r = rootOf(t); if (!r) return;
    if (t.hasAttribute && t.hasAttribute('data-flz-continue')) setTimeout(function () { reset(r); }, 0);
    else if (t.closest && t.closest('[data-flz-inputs] button,[data-flz-modes] button,[data-flz-result] [data-flz-usemin]')) reset(r);
  });
  /* FL14-STOCK-001: when a product's stock is tracked and limited, the customer is told before adding if the quantity is more than can still be added (stock minus what is already in the cart). Display and button state only; the cart request is unchanged. */
  var PL = { box: 'boxes', piece: 'pieces', tile: 'tiles', 'linear foot': 'linear feet', roll: 'rolls', card: 'cards', item: 'items', sink: 'sinks', sheet: 'sheets' }, SG = {};
  Object.keys(PL).forEach(function (k) { SG[PL[k]] = k; });
  function stockOf(root) {
    var d; try { d = JSON.parse(root.querySelector('[data-flz-product-json]').textContent); } catch (e) { return null; }
    var vs = root.querySelector('[data-flz-variant]'), id = vs ? +vs.value : d.selected_variant_id;
    var v = (d.variants || []).filter(function (x) { return x.id === id; })[0] || (d.variants || [])[0];
    return v && typeof v.stock === 'number' ? { id: v.id, stock: v.stock } : null;
  }
  function held(root, cart) { var h = {}; (cart.items || []).forEach(function (i) { h[i.variant_id] = (h[i.variant_id] || 0) + i.quantity; }); root.__flzHeld = h; }
  function words(u) { u = (u || '').trim().toLowerCase(); var one = SG[u] || u, many = PL[one] || u; return function (n) { return n === 1 ? one : many; }; }
  function check(root) {
    var r = root.querySelector('[data-flz-result]'); if (!r || r.querySelector('[data-flz-stock]') || !root.__flzHeld) return;
    if (/[?&]flz_edit=/.test(window.location.search)) return;
    var s = stockOf(root), big = r.querySelector('.flz-need .flz-big'); if (!s || !big) return;
    var n = parseInt(big.textContent.replace(/[^0-9]/g, ''), 10), have = root.__flzHeld[s.id] || 0, left = s.stock - have; if (!(n > left)) return;
    var u = words((r.querySelector('.flz-need .flz-unit') || {}).textContent), p = document.createElement('p');
    p.className = 'flz-note'; p.setAttribute('data-flz-stock', '');
    p.textContent = left <= 0 ? 'All ' + s.stock + ' available ' + u(s.stock) + ' of this item are already in your cart, so no more can be added.' : 'Only ' + left + ' more ' + u(left) + ' can be added. ' + s.stock + ' ' + (s.stock === 1 ? 'is' : 'are') + ' available' + (have ? ' and ' + have + ' ' + (have === 1 ? 'is' : 'are') + ' already in your cart' : '') + '. Nothing has been added to your cart.';
    r.appendChild(p);
    var b = root.querySelector('[data-flz-add]'), bar = root.querySelector('[data-flz-bar]'); if (b) b.disabled = true; if (bar) bar.classList.remove('is-on');
  }
  function stockWatch(root) {
    if (!stockOf(root) && !root.querySelector('[data-flz-variant]')) return;
    var r = root.querySelector('[data-flz-result]'); if (!r) return;
    var load = function (now) { return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }).then(function (c) { held(root, c); if (now === true) check(root); }).catch(function () { }); };   // after an add, the new count applies from the next change the customer makes
    new MutationObserver(function () { check(root); }).observe(r, { childList: true, subtree: true });
    document.addEventListener('flooritize:cart-updated', function () { load(false); });
    load(true);
  }
  function boot() { document.querySelectorAll('[data-flz-product]').forEach(function (r) { watch(r); stockWatch(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
